import { PropsWithChildren } from "react";
import { styled } from "styled-components";
import { Typography } from "../../../typography";
import {
  Content,
  Header,
  Inner,
  LinkWrapper,
  StyledImage,
  StyledRow,
  StyledTypography,
  Wrapper,
} from "./card.styles";
import { Button, Icon as UIIcon } from "@mindlercare/ui-web";
import { CardProps } from "./card.types";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  grid-template-rows: max-content max-content;
  color: ${(props) => props.theme.COLORS.BLACK_GREY};
  /* Child selector */
  > * {
    align-self: center;
  }
`;

const NullIcon = () => null;

export const Column = ({
  icon,
  title,
  content,
  link,
  buttonText,
  dataTestId,
  id,
  image,
  status,
  onClick,
}: CardProps) => {
  const Icon = icon ? UIIcon[icon as keyof typeof UIIcon] : NullIcon;
  if (link) {
    return (
      <LinkWrapper
        {...(dataTestId && { "data-testid": dataTestId })}
        {...(id && { id })}
        to={link}
      >
        <Inner>
          {image && <StyledImage src={image} />}
          <Header {...(image && { hasImage: true })}>
            <GridContainer>
              {icon && <Icon />}
              <Typography insensitive variant="h3">
                {title}
              </Typography>
              <div />
              {status}
            </GridContainer>
          </Header>
          <Content>
            <StyledTypography variant="body">{content}</StyledTypography>
          </Content>
          <Button variant="primary">{buttonText}</Button>
        </Inner>
      </LinkWrapper>
    );
  }

  return (
    <Wrapper
      {...(dataTestId && { "data-testid": dataTestId })}
      {...(id && { id })}
      {...(onClick && { onClick })}
    >
      <Inner>
        {image && <StyledImage src={image} />}
        <Header {...(image && { hasImage: true })}>
          <GridContainer>
            {icon && <Icon />}
            <Typography insensitive variant="h3">
              {title}
            </Typography>
            <div />
            {status}
          </GridContainer>
        </Header>
        <Content>
          <StyledTypography variant="body">{content}</StyledTypography>
        </Content>
        <Button variant="primary">{buttonText}</Button>
      </Inner>
    </Wrapper>
  );
};

export const Row = ({
  children,
  id,
  dataTestId,
}: PropsWithChildren<{ id?: string; dataTestId?: string }>) => {
  return (
    <StyledRow
      {...(dataTestId && { "data-testid": dataTestId })}
      {...(id && { id })}
    >
      {children}
    </StyledRow>
  );
};
